import { isTauri } from '@tauri-apps/api/core';
import { openUrl } from '@tauri-apps/plugin-opener';

export function openExternal(url) {
  if (isTauri()) return openUrl(url);
  if (url.startsWith('http')) window.open(url, '_blank', 'noopener');
  else window.location.href = url;
}
